<div class="nav-buttons-container">
  <button
    *ngFor="let button of buttons"
    class="nav-button"
    (click)="handleClick(button)"
    [attr.aria-label]="button.label">
    <!-- <span class="button-icon material-icons">{{ button.icon }}</span> -->
     <img class="button-icon" alt="img" id="list-logo" [src]=" button.icon">
    <span class="button-label">{{ button.label }}</span>
  </button>
</div>

